import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const ThankYouSteps = () => {
  const steps = [
    {
      icon: "Mail",
      title: "Verifique seu E-mail",
      desc: "Enviamos os detalhes do seu benefício de 15%. Responda 'OK' para confirmar o recebimento."
    },
    {
      icon: "MessageCircle",
      title: "Chame no WhatsApp",
      desc: "Envie uma mensagem agora para validar seu cupom e consultar a disponibilidade da agenda.",
      isPrimary: true
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
      {steps.map((step, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0, x: i === 0 ? -20 : 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.8 + (i * 0.2) }}
          className={`p-6 rounded-2xl border ${step.isPrimary ? 'bg-stone-900 border-stone-800 text-white shadow-xl' : 'bg-white border-stone-200 text-stone-800'}`}
        >
          <div className={`w-10 h-10 rounded-xl flex items-center justify-center mb-4 ${step.isPrimary ? 'bg-amber-500 text-stone-900' : 'bg-amber-100 text-amber-800'}`}>
            <SafeIcon name={step.icon} className="w-5 h-5" />
          </div>
          <h3 className="font-serif text-xl font-bold mb-2">{step.title}</h3>
          <p className={`text-sm leading-relaxed mb-6 ${step.isPrimary ? 'text-stone-300' : 'text-stone-500'}`}>
            {step.desc}
          </p>
          
          {step.isPrimary && (
            <a 
              href="http://wa.me/5532999857587" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-white text-stone-900 px-6 py-3 rounded-xl font-bold text-xs uppercase tracking-widest hover:bg-amber-50 transition-colors w-full justify-center"
            >
              🟢 Chame agora no WPP!
              <SafeIcon name="ExternalLink" className="w-3 h-3" />
            </a>
          )}
        </motion.div>
      ))}
    </div>
  );
};

export default ThankYouSteps;